import React, { useEffect, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './RequestChangesModal.css';

const RequestChangesModal = ({ show, onHide }) => {
    const messages = [
        {
            id: 1,
            type: "received",
            text: "Doc Gio has a schedule change, kindly confirm before I approve this",
            timestamp: "2025-03-19T07:35:00",
        },
        {
            id: 2,
            type: "sent",
            text: "Got it. Tawagan ko sya mamaya",
            timestamp: "2025-03-19T07:45:00",
        },
        {
            id: 3,
            type: "system",
            text: "March 19, 2025 9:32am — Agent Plan was submitted for approval",
            timestamp: "2025-03-19T09:32:00",
        },
        {
            id: 4,
            type: "received",
            text: "Doc Gio has a schedule change, kindly confirm before I approve this",
            timestamp: "2025-03-19T07:35:00",
        },
        {
            id: 5,
            type: "sent",
            text: "Got it. Tawagan ko sya mamaya",
            timestamp: "2025-03-19T07:45:00",
        },
        ,
        {
            id: 6,
            type: "received",
            text: "Doc Gio has a schedule change, kindly confirm before I approve this",
            timestamp: "2025-03-19T07:35:00",
        },
        {
            id: 7,
            type: "sent",
            text: "Got it. Tawagan ko sya mamaya",
            timestamp: "2025-03-19T07:45:00",
        },
    ];

    const chatBoxRef = useRef(null);

    useEffect(() => {
        if (show && chatBoxRef.current) {
            const scrollToBottom = () => {
                chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
            };

            // Timeout ensures scroll happens after modal is rendered
            setTimeout(scrollToBottom, 50);
        }
    }, [show, messages]);


    return (
        <Modal className="request-changes-modal" show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                Request Changes
            </Modal.Header>
            <Modal.Body ref={chatBoxRef}>
                <div className="chat-box">
                    {messages.map((msg) => {
                        if (msg.type === "system") {
                            return (
                                <div key={msg.id} className="system-message">
                                    {msg.text}
                                </div>
                            );
                        }

                        return (
                            <div key={msg.id} className={`chat-message ${msg.type}`}>
                                <div className="chat-bubble">
                                    <div className="chat-meta">
                                        {new Date(msg.timestamp).toLocaleString()}
                                    </div>
                                    <div className='chat-text'>{msg.text}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Form.Group className="m-0 my-2 w-100">
                    <div>Enter your comment</div>
                    <Form.Control
                        as="textarea"
                        rows={3}
                    />
                </Form.Group>
                <Button className="request-changes-btn" onClick={onHide}>
                    Request Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RequestChangesModal;
